import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable, of } from 'rxjs';
import { ApplicationSettingsResult } from 'src/app/shared/models/maintenance/settings.service.model';
import { environment } from 'src/environments/environment';
import { BaseService } from '../base/base.service';
import { CacheService } from '../cache.service';

@Injectable({
  providedIn: 'root',
})
export class SettingsService extends BaseService {
  private readonly urlPrefix = `${environment.maintenance.urlPrefix}/settings`;

  constructor(
    http: HttpClient,
    private cache: CacheService,
    private oidcSecurityService: OidcSecurityService
  ) {
    super(http);
  }

  public getAppSettings(): Observable<ApplicationSettingsResult> {
    if (!this.oidcSecurityService.getUserData()) return of();

    return this.cache.get(
      `${this.constructor.name}_${this.getAppSettings.name}`,
      `${this.oidcSecurityService.getUserData()['sub']}`,
      this.get(`${this.urlPrefix}/application`),
      []
    );
  }
}
